import { c as _c } from "react/compiler-runtime";
import { Navigate } from "react-router-dom";
import { usePreservedSearch } from "@hooks/use-preserved-search";
import { forwardRef } from "react";
/**
 * A custom Navigate component that preserves query parameters when navigating to a new route.
 * Use forwardRef to forward the ref to Navigate component.
 */
export const PreservingNavigate = forwardRef((t0, _ref) => {
  const $ = _c(6);
  let rest;
  let to;
  if ($[0] !== t0) {
    ({
      to,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = to;
  } else {
    rest = $[1];
    to = $[2];
  }
  const toWithSearch = usePreservedSearch(to);
  let t1;
  if ($[3] !== rest || $[4] !== toWithSearch) {
    t1 = <Navigate to={toWithSearch} {...rest} />;
    $[3] = rest;
    $[4] = toWithSearch;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
});